import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { TranslateService } from '@ngx-translate/core';

export interface ConfirmOptions{
	title?: string; 
	text: string; 
	yesText?: string; 
	noText?: string;
}

@Injectable({ 
	providedIn: 'any'
})
export class ConfirmDialog {
	constructor(
		private readonly modal: NzModalService,
		private readonly translationService: TranslateService
	) { }
	
	public async prompt({title, text, yesText, noText}: ConfirmOptions): Promise<boolean> {
		title ??= await this.translationService.get( 'generic.confirm.title').toPromise();
		yesText ??= await this.translationService.get( 'generic.confirm.yes').toPromise();
		noText ??= await this.translationService.get( 'generic.confirm.no').toPromise();
		
		return await new Promise(resolve=> 
			this.modal.create<void, boolean>({
				nzTitle: title,
				nzContent: text,
				nzOkText: yesText,
				nzCancelText: noText,
				nzOnOk: () => resolve(true),
				nzOnCancel: () => resolve(false),
				nzClosable: false
			})
		);
	}
}
